export const fmtEur = (v) => (Number(v) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

// Coût par inscrit affiché dans la LISTE : coût hors Ads seulement (pas d'appel
// Athena par ligne) ; "—" si aucun inscrit. Le coût complet (Ads inclus) est dans
// la modale ROI.
export function costPerRegistrationLabel(event) {
    const cost = Number(event && event.cost) || 0;
    const registered = Number(event && event.countOfHumans) || 0;
    if (registered === 0) return "—";
    return fmtEur(cost / registered);
}

export function hasAdSets(event) {
    return Array.isArray(event && event.adSetIDs) && event.adSetIDs.length > 0;
}
